export default __webpack_public_path__ + "Icon/icons/outlined/wifiOff.svg";